var getResizeUrl = function (_a) {
    var poiY = _a.poiY, poiX = _a.poiX, src = _a.src, outHeight = _a.outHeight, outWidth = _a.outWidth, format = _a.format, downloadFilename = _a.downloadFilename, addExtensionAtEnd = _a.addExtensionAtEnd;
    var params = new URLSearchParams();
    params.set("t", "fill-down");
    params.set("src", src);
    params.set("f", format);
    params.set("w", outWidth.toString());
    params.set("h", outHeight.toString());
    params.set("poiX", poiX.toString());
    params.set("poiY", poiY.toString());
    downloadFilename && params.set("fn", "".concat(downloadFilename, ".").concat(format.toLocaleLowerCase()));
    // Warning: this parameter must always be at the end of the URL
    // so that third-party tools which consume the generated image
    // (like Drupal which looks at the extension to generate the preview) work correctly!
    addExtensionAtEnd && params.set("extension", ".".concat(format.toLowerCase()));
    return "/resize?".concat(params.toString());
};

export { getResizeUrl };
//# sourceMappingURL=utils.js.map
